import { Contact } from "../../../app/services/response-models/contacts.response.model";

export class SaveCurrentContact {
    public static readonly type = "[Contact] Save current contact";

    constructor(public payload: Contact) {}
}
